import { ParameterType } from '@/study-search/enums';

import { Filter } from '../Filter';
import { IIndexation } from '../../../interfaces';
import { FormatFilterOptionValue } from '@studyportals/search-filters';
import { FilterKey } from '@studyportals/search-filters';

export class FormatFilter extends Filter implements IIndexation {
	public constructor() {
		super(FilterKey.ATTENDANCE, ParameterType.ATTENDANCE, []);
	}

	public canBeIndexed(): boolean {
		return this.values.length === 1 && this.values.includes(FormatFilterOptionValue.PART_TIME);
	}
}
